import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  // Announced, never shown. The region must exist BEFORE its content changes
  // or assistive tech never observes the mutation.
  srOnly: {
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap'
  },
  idle: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2)
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2, 0)
  },
  section: {
    marginBottom: theme.spacing(2)
  },
  truncationNote: {
    display: 'block',
    marginTop: theme.spacing(1)
  }
}))

export default useStyles
